import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { Subscription } from 'rxjs';

import { AuthService } from 'app/providers/bridge-api/auth.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Group, GroupService } from '../../../../providers/semantria-api/group.service';
import {
  SemantriaUser,
  SemantriaUsersService,
} from '../../../../providers/semantria-api/semantria-users.service';
import { AlertService } from '../../../../services/alert.service';
import { DialogService } from '../../../../services/dialog.service';
import { PermissionTableComponent } from './permission-table.component';
@EnableClassTelemetry()
@Component({
  selector: 'app-user-permission-table',
  templateUrl: './permission-table.component.html',
  styleUrls: ['./permission-table.component.scss'],
  standalone: false,
})
export class UserPermissionTableComponent
  extends PermissionTableComponent<SemantriaUser, Group>
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  isAdmin: boolean;
  adminToolTipResponse: string;
  translationSubscription: Subscription;
  constructor(
    protected groupService: GroupService,
    protected userService: SemantriaUsersService,
    protected dialogService: DialogService,
    protected authService: AuthService,
    protected alertService: AlertService,
    protected changeDetector: ChangeDetectorRef,
    public translocoService: TranslocoService
  ) {
    super(
      groupService,
      userService,
      dialogService,
      authService,
      alertService,
      changeDetector,
      translocoService
    );
    this.itemType = 'user-groups';
    this.sortFnFactory = (sort, direction) => (u1: Group, u2: Group) => {
      switch (sort.active) {
        case 'name':
          return this.propSort(u1, u2, 'group_name', direction);
        case 'read':
          return u1.group_name.localeCompare(u2.group_name) * direction;
        case 'all':
          return u1.group_name.localeCompare(u2.group_name) * direction;
        default:
          return 0;
      }
    };
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.translationSubscription = this.translocoService
      .selectTranslateObject('user-permission-table')
      .subscribe((translatedValue) => {
        this.adminToolTipResponse = translatedValue['admin-failure'];
      });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.parent) {
      this.isAdmin = this.parent.permissions.some((p) => p.permission_type === 'ACCOUNT_ADMIN');
    }
  }

  ngOnDestroy() {
    this.translationSubscription?.unsubscribe();
  }

  getName(item) {
    return item.group_name;
  }

  getEmail() {
    return;
  }

  getId(item) {
    return item.group_id;
  }

  getUser() {
    return this.parent;
  }

  getUserId() {
    return this.parent.user_id;
  }

  getGroupId(item) {
    return item.group_id;
  }

  canAddItem() {
    return (
      !this.authService.isReadOnly &&
      !this.isAdmin &&
      !this.isLoading &&
      this.remainingItems.length > 0
    );
  }

  get addToolTip() {
    if (this.isAdmin) {
      return this.adminToolTipResponse;
    }
    return super.addToolTip;
  }
}
